import gsap from "@/lib/gsap";

export default function (element, dataset) {
  const listItems = element.querySelectorAll('[role="listitem"]');


  if (!listItems?.length) {
    return;
  }

  const animation = gsap.to(listItems, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    delay: 0.5,
    ease: "power2.out",
    stagger: {
      each: 0.08,
      from: "start",
    },
  });

  return () => {
    animation.kill();
  };
}
